
// import axios from "axios";

// const API_URL =
//   process.env.REACT_APP_API_URL || "http://localhost:8000";

// /*
// =========================================================
// AUTH HEADERS
// =========================================================
// */
// const getAuthHeaders = () => {
//   const storedUser =
//     localStorage.getItem("user") ||
//     localStorage.getItem("localUser");

//   const user = storedUser ? JSON.parse(storedUser) : null;

//   if (!user?.id) {
//     throw new Error("User session not found. Please login again.");
//   }

//   const token =
//     localStorage.getItem("token") ||
//     localStorage.getItem("jwt");

//   const headers = {
//     "Content-Type": "application/json",
//     "X-User-Id": String(user.id),
//   };

//   if (token) {
//     headers["Authorization"] = `Bearer ${token}`;
//   }

//   return headers;
// };

// /*
// =========================================================
// GET JOB LIST
// =========================================================
// */
// export const fetchJobList = async ({
//   page = 1,
//   pageSize = 20,
//   campaignId = "",
//   brandId = "",
//   status = "",
//   discrepancy = "",
//   search = "",
// } = {}) => {
//   const params = {
//     page,
//     page_size: pageSize,
//   };

//   if (campaignId) {
//     params.campaign_id = campaignId;
//   }

//   if (brandId) {
//     params.brand_id = brandId;
//   }

//   if (status) {
//     params.status = status;
//   }

//   if (discrepancy) {
//     params.discrepancy = discrepancy;
//   }

//   if (search) {
//     params.search = search;
//   }

//   const response = await axios.get(
//     `${API_URL}/api/job-list`,
//     {
//       params,
//       headers: getAuthHeaders(),
//       credentials: "include",
//     }
//   );

//   return response.data;
// };

// /*
// =========================================================
// GET FILTER VALUES
// =========================================================
// */
// export const fetchJobListFilters = async () => {
//   const response = await axios.get(
//     `${API_URL}/api/job-list/filters`,
//     {
//       headers: getAuthHeaders(),
//       credentials: "include",
//     }
//   );

//   return response.data;
// };

// /*
// =========================================================
// GET JOB MEDIA / INSPECTION PHOTOS
// =========================================================
// */
// export const fetchJobMedia = async (requestId) => {
//   if (!requestId) {
//     throw new Error("Request ID is required.");
//   }

//   console.log(
//     "[JOB LIST SERVICE] Fetching inspection media for request_id:",
//     requestId
//   );

//   const response = await axios.get(
//     `${API_URL}/api/inspection-photos/${requestId}`,
//     {
//       headers: getAuthHeaders(),
//       credentials: "include",
//     }
//   );

//   return response.data;
// };

// /*
// =========================================================
// GET SINGLE JOB
// =========================================================
// */
// export const fetchJobById = async (jobId) => {
//   if (!jobId) {
//     throw new Error("Job ID is required.");
//   }

//   const response = await axios.get(
//     `${API_URL}/api/job-list/${jobId}`,
//     {
//       headers: getAuthHeaders(),
//       credentials: "include",
//     }
//   );

//   return response.data;
// }; 


import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000";

/*
=========================================================
AUTH HEADERS
=========================================================
*/
const getAuthHeaders = () => {
  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  const user = storedUser ? JSON.parse(storedUser) : null;

  if (!user?.id) {
    throw new Error("User session not found. Please login again.");
  }

  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("jwt");

  const headers = {
    "Content-Type": "application/json",
    "X-User-Id": String(user.id),
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return headers;
};

/*
=========================================================
GET JOB LIST
=========================================================
*/
export const fetchJobList = async ({
  page = 1,
  pageSize = 20,
  campaignId = "",
  brandId = "",
  status = "",
  discrepancy = "",
  search = "",
} = {}) => {
  const params = {
    page,
    page_size: pageSize,
  };

  if (campaignId) {
    params.campaign_id = campaignId;
  }

  if (brandId) {
    params.brand_id = brandId;
  }

  if (status) {
    params.status = status;
  }

  if (discrepancy) {
    params.discrepancy = discrepancy;
  }

  if (search) {
    params.search = search;
  }

  const response = await axios.get(
    `${API_URL}/api/job-list`,
    {
      params,
      headers: getAuthHeaders(),
      credentials: "include",
    }
  );

  return response.data;
};

/*
=========================================================
GET FILTER VALUES
=========================================================
*/
export const fetchJobListFilters = async () => {
  const response = await axios.get(
    `${API_URL}/api/job-list/filters`,
    {
      headers: getAuthHeaders(),
      credentials: "include",
    }
  );

  return response.data;
};

/*
=========================================================
GET JOB MEDIA / INSPECTION PHOTOS
=========================================================
*/
export const fetchJobMedia = async (requestId) => {
  if (!requestId) {
    throw new Error("Request ID is required.");
  }

  console.log(
    "[JOB LIST SERVICE] Fetching inspection media for request_id:",
    requestId
  );

  const response = await axios.get(
    `${API_URL}/api/inspection-photos/${requestId}`,
    {
      headers: getAuthHeaders(),
      credentials: "include",
    }
  );

  return response.data;
};

/*
=========================================================
GET SINGLE JOB
=========================================================
*/
export const fetchJobById = async (jobId) => {
  if (!jobId) {
    throw new Error("Job ID is required.");
  }

  const response = await axios.get(
    `${API_URL}/api/job-list/${jobId}`,
    {
      headers: getAuthHeaders(),
      credentials: "include",
    }
  );

  return response.data;
}; 

